module.exports = __webpack_public_path__ + "img/core-active-3.8de3940.png";